import { Phone, Mail, User, Building2, MapPin, FileText, Hash } from "lucide-react";
import { CONTACT } from "../../data/content";
import { Reveal, Overline } from "./Reveal";

const ROWS = [
  { icon: User, label: "Kapcsolattartó", value: CONTACT.person },
  { icon: Building2, label: "Cégnév", value: CONTACT.company },
  { icon: MapPin, label: "Cím", value: CONTACT.address },
  { icon: FileText, label: "Adószám", value: CONTACT.taxNumber },
  { icon: Hash, label: "Cégjegyzékszám", value: CONTACT.regNumber },
];

export default function Contact() {
  return (
    <section id="kapcsolat" data-testid="contact-section" className="scroll-mt-24 bg-white py-16 sm:py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <Reveal><Overline>Kapcsolat</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-gradient-brand text-balance">
              Vegye fel velünk a kapcsolatot
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Reveal>
                <a href={CONTACT.phoneHref} data-testid="contact-phone" className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-5 hover:border-emerald-300 hover:bg-white hover:shadow-lg transition-all">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0E5A75] text-white"><Phone className="h-5 w-5" /></span>
                  <span>
                    <span className="block text-xs uppercase tracking-wide text-slate-500">Telefon</span>
                    <span className="block font-bold text-[#0E5A75]">{CONTACT.phoneDisplay}</span>
                  </span>
                </a>
              </Reveal>
              <Reveal delay={0.06}>
                <a href={CONTACT.emailHref} data-testid="contact-email" className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-5 hover:border-emerald-300 hover:bg-white hover:shadow-lg transition-all">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0E5A75] text-white"><Mail className="h-5 w-5" /></span>
                  <span className="min-w-0">
                    <span className="block text-xs uppercase tracking-wide text-slate-500">E-mail</span>
                    <span className="block font-bold text-[#0E5A75] truncate">{CONTACT.email}</span>
                  </span>
                </a>
              </Reveal>
            </div>

            <Reveal delay={0.1}>
              <dl className="mt-4 divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white">
                {ROWS.map((r) => {
                  const Icon = r.icon;
                  return (
                    <div key={r.label} className="flex items-start gap-4 px-5 py-4">
                      <Icon className="h-5 w-5 shrink-0 text-emerald-500 mt-0.5" />
                      <div>
                        <dt className="text-xs uppercase tracking-wide text-slate-500">{r.label}</dt>
                        <dd className="font-semibold text-[#0E5A75]">{r.value}</dd>
                      </div>
                    </div>
                  );
                })}
              </dl>
            </Reveal>
          </div>

          <div className="h-full min-h-[420px] lg:min-h-[560px] overflow-hidden rounded-[2rem] border border-slate-200 shadow-xl">
            <iframe
              title="Tetőklinika térkép"
              src={CONTACT.mapEmbed}
              width="100%"
              height="100%"
              className="block h-full w-full min-h-[420px] lg:min-h-[560px]"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
